import BookingForm from '@/components/feature/BookingForm';
import { bookingImage, brandInfo } from '@/mocks/site';

export default function BookingSection() {
  const contacts = [
    { label: 'Phone', node: <a href={brandInfo.phoneHref} className="hover:text-primary-400 transition-colors cursor-pointer">{brandInfo.phone}</a> },
    { label: 'Location', node: <span>{brandInfo.address}, {brandInfo.city}</span> },
    { label: 'Hours', node: <span>Mon–Fri {brandInfo.hours[0].time}</span> },
  ];

  return (
    <section id="booking" className="relative py-16 md:py-24 lg:py-[104px] bg-background-50 overflow-hidden">
      <div className="relative mx-auto max-w-[1280px] px-4 md:px-8 lg:px-10 grid grid-cols-1 lg:grid-cols-12 lg:items-stretch gap-12 lg:gap-x-[72px]">
        <div className="lg:col-span-5 flex flex-col lg:h-full">
          <div>
            <h2 className="font-heading uppercase whitespace-nowrap text-[32px] sm:text-[40px] md:text-[56px] lg:text-[46px] xl:text-[54px] leading-[0.92]">Book a <span className="text-primary-500">service.</span></h2>
            <p className="mt-5 text-[15px] text-foreground-700 max-w-sm leading-relaxed">Send a request and we&apos;ll call to confirm a time that suits you.</p>
          </div>

          <div className="relative my-8 lg:my-6 h-[220px] md:h-[300px] lg:h-auto lg:flex-1 lg:min-h-[280px] -mx-4 md:mx-0 lg:-mr-10 pointer-events-none" aria-hidden="true">
            <img src={bookingImage} alt="" className="absolute inset-0 w-full h-full object-cover object-center opacity-90 saturate-[0.9]" />
            <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-transparent via-40% to-background-50/90" />
            <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-transparent to-background-50" />
          </div>

          <dl className="flex flex-col gap-4">
            {contacts.map((c) => (
              <div key={c.label} className="flex flex-wrap items-baseline gap-x-6 gap-y-1 text-sm">
                <dt className="w-20 shrink-0 text-[11px] uppercase tracking-[0.14em] text-foreground-600 font-label">{c.label}</dt>
                <dd className="text-foreground-900">{c.node}</dd>
              </div>
            ))}
          </dl>
        </div>
        <div className="lg:col-span-7 flex flex-col lg:pt-[62px] xl:pt-[70px]">
          <BookingForm variant="linear" />
        </div>
      </div>
    </section>
  );
}